<div class="relationships-form form-paginator">
  <div class="table-header">
    <button mat-raised-button color="primary" (click)="addNewRelationship()">
      <i class="fa fa-plus" style="margin-right:10px;"></i> Add Relationship
    </button>
  </div>

  <div class="relationships-table-container">
    <div>
      <mat-paginator [pageSizeOptions]="[5,10,15,20]"></mat-paginator>
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="dataSource"
        multiTemplateDataRows
        class="relationships-table">

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let relationship" class="icon-cell">
            <div class="row center justify-center min-height">
              @if (editingRelationship === relationship) {
                <i class="fa fa-save" (click)="saveRelationship(relationship)"
                matTooltip="Save"></i>
                <i class="fa fa-times" (click)="cancelEdit()"
                matTooltip="Cancel"></i>
              } @else {
                <i class="fa fa-edit" (click)="startEdit(relationship)"
                matTooltip="Edit"></i>
                <i class="fa fa-trash" (click)="deleteRelationship(relationship)"
                matTooltip="Delete relationship"></i>
              }
            </div>
          </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let relationship">
            <div>
              <mat-form-field class="show-select-arrow no-label">
                <mat-select [(ngModel)]="relationship.type"
                  (selectionChange)="onTypeChange(relationship, $event.value)"
                  name="type" class="show-select-arrow"
                  [disabled]="relationship.second_type_id === parentComponentType.id || !isEditing(relationship)">
                  <mat-option value="component">Component</mat-option>
                  <mat-option value="event">Event</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <!-- First Type Name Column -->
        <ng-container matColumnDef="firstTypeName">
          <th mat-header-cell *matHeaderCellDef>First Type</th>
          <td mat-cell *matCellDef="let relationship"
            [matTooltip]="relationship.first_type_name"
            [matTooltipShowDelay]="1000">
            {{relationship.first_type_name}}
          </td>
        </ng-container>

        <!-- Second Type Name Column -->
        <ng-container matColumnDef="secondTypeName">
          <th mat-header-cell *matHeaderCellDef>Second Type</th>
          <td mat-cell *matCellDef="let relationship">
            <div>
              <select-search-component
                [api_model]="relationship.type==='component'?'component_type':'event_type'"
                [custom_filters]="relationship.type==='component'? availableComponentTypesFilter:availableEventTypesFilter"
                [value]="relationship.second_type_id"
                (selectionChange)="onSecondObjectChange(relationship, $event.value)"
                [compareFunctionName]="'compareValueToId'"
                [classes]="'fill show-select-arrow'"
                [disabled]="relationship.second_type_id === parentComponentType.id || !isEditing(relationship)"
                class="select-search show-select-arrow">
              </select-search-component>
            </div>
          </td>
        </ng-container>

        <!-- First Is Unique Column -->
        <ng-container matColumnDef="firstIsUnique">
          <th mat-header-cell *matHeaderCellDef>First Unique</th>
          <td mat-cell *matCellDef="let relationship" class="checkbox-cell">
            <mat-checkbox [(ngModel)]="relationship.first_is_unique"
              [disabled]="!isEditing(relationship)"
              color="primary"
              aria-label="First Is Unique">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Second Is Unique Column -->
        <ng-container matColumnDef="secondIsUnique">
          <th mat-header-cell *matHeaderCellDef>Second Unique</th>
          <td mat-cell *matCellDef="let relationship" class="checkbox-cell">
            <mat-checkbox [(ngModel)]="relationship.second_is_unique"
              [disabled]="!isEditing(relationship)"
              color="primary"
              aria-label="Second Is Unique">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Automatic Unlink Column -->
        <ng-container matColumnDef="automaticUnlink">
          <th mat-header-cell *matHeaderCellDef>Auto Unlink</th>
          <td mat-cell *matCellDef="let relationship" class="checkbox-cell">
            <mat-checkbox [(ngModel)]="relationship.automatic_unlink"
              [disabled]="!isEditing(relationship)"
              color="primary"
              aria-label="Automatic Unlink">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- Automatic Linking Rule Column -->
        <ng-container matColumnDef="automaticLinkingRule">
          <th mat-header-cell *matHeaderCellDef>Linking Rule</th>
          <td mat-cell *matCellDef="let relationship" class="rule-cell">
            <div class="row center min-height">
              <button class="configure-rule" mat-flat-button
                [disabled]="!relationship.second_type_id || !isEditing(relationship)"
                (click)="configureAutomaticLinking(relationship)">
                <i class="fa fa-cog"
                matTooltip="Configure Linking Rule"></i></button>
                <div class="rule-content" [matTooltip]="relationship.automatic_linking_rule || 'No rule configured'"
                  [matTooltipShowDelay]="500">
                  @if (relationship.automatic_linking_rule) {
                    <code>{{relationship.automatic_linking_rule}}</code>
                  } @else {
                    <span class="no-rule">No rule configured</span>
                  }
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Expanded Content Column -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let relationship"
              [attr.colspan]="displayedColumns.length"
              class="formula-builder-cell">
              <div [@detailExpand]="relationship === expandedElement ? 'expanded' : 'collapsed'"
                class="formula-detail">
                @if (expandedElement === relationship) {
                  <formula-builder-relationship-rules
                    [parentComponent]="parentComponentType"
                    [relationship_type]="relationship.type"
                    [second_object]="secondObject"
                    [formula]="relationship.automatic_linking_rule"
                    (formulaChange)="onFormulaChange($event)">
                  </formula-builder-relationship-rules>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let relationship; columns: displayedColumns;"
            [ngClass]="{
              'expanded-row': expandedElement === relationship,
              'editing-row': editingRelationship === relationship,
              'new-row': relationship.isNew
            }">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
            [class.detail-not-expanded]="expandedElement !== row"
            class="detail-row">
          </tr>

        </table>
      </div>
    </div>
  </div>
